import {
  StudentDetails,
  StudentDetailsGender,
  StudentDetailsMaritalStatus,
} from '../../components/LandingPage/StudentDetails';
import { TdFormState } from './TdGicForm';

export enum TdSupportedCountriesOfResidence {
  China = 'CN',
  India = 'IN',
  Morocco = 'MA',
  Pakistan = 'PK',
  Philippines = 'PH',
  Senegal = 'SN',
  Vietnam = 'VN',
}

export enum TdPrefix {
  Mr = 'Mr.',
  Ms = 'Ms.',
  Mrs = 'Mrs.',
}

export const TD_GIC_FORM_DEFAULT_VALUES: TdFormState = {
  prefix: '',
  firstName: '',
  lastName: '',
  mobileNumber: '',
  emailAddress: '',
  countryOfResidence: '',
  preferredLanguage: '',
  isConsentToApplyboardTermsAndConditions: false,
  isAgreeToApplyBoardCommunications: false,
  dateOfBirth: '',
  confirmDateOfBirth: '',
  isAgreeToTdAgreements: false,
  nationalPhoneNumber: '',
  countryCallingCode: '',
};

export const getTdPrefix = (
  gender: StudentDetailsGender | undefined,
  maritalStatus: StudentDetailsMaritalStatus | undefined,
) => {
  if (gender === StudentDetailsGender.Female) {
    if (maritalStatus === StudentDetailsMaritalStatus.Married) {
      return TdPrefix.Mrs;
    }
    return TdPrefix.Ms;
  }
  return TdPrefix.Mr;
};

export const autoFillDataTDFormState = (autofillData?: StudentDetails): TdFormState => {
  if (!autofillData) {
    const formState: TdFormState = {
      ...TD_GIC_FORM_DEFAULT_VALUES,
    };
    return formState;
  }
  const formState: TdFormState = {
    ...TD_GIC_FORM_DEFAULT_VALUES,
    prefix: getTdPrefix(autofillData.student?.gender, autofillData.student?.maritalStatus),
    firstName: autofillData.student?.givenName ?? TD_GIC_FORM_DEFAULT_VALUES.firstName,
    lastName: autofillData.student?.surname ?? TD_GIC_FORM_DEFAULT_VALUES.lastName,
    mobileNumber: autofillData.contact?.phoneNumber ?? TD_GIC_FORM_DEFAULT_VALUES.mobileNumber,
    emailAddress: autofillData.contact?.emailAddress ?? TD_GIC_FORM_DEFAULT_VALUES.emailAddress,
    dateOfBirth:
      autofillData.student?.dateOfBirth?.toISOString() ?? TD_GIC_FORM_DEFAULT_VALUES.dateOfBirth,
    countryOfResidence:
      autofillData.residentialAddress?.country ?? TD_GIC_FORM_DEFAULT_VALUES.countryOfResidence,
  };
  return formState;
};
